import { render, staticRenderFns } from "./WHColor.vue?vue&type=template&id=fc9ddb7a&"
import script from "./WHColor.vue?vue&type=script&lang=js&"
export * from "./WHColor.vue?vue&type=script&lang=js&"
import style0 from "./WHColor.vue?vue&type=style&index=0&id=fc9ddb7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports